// Error and Message Related
export const ErrorActions = {
  ALL_ERRORS: 'ALL_ERRORS',
  CLEAR_ALL: 'CLEAR_ALL',
  CLEAR_ERRORS: 'CLEAR_ERRORS',
  SET_ERROR_STATE: 'SET_ERROR_STATE',
  GET_ERRORS: 'GET_ERRORS',
  LOG_ERRORS: 'LOG_ERRORS',
} as const;

export const MessageActions = {
  CREATE_MESSAGE: 'CREATE_MESSAGE',
  UPDATE_MESSAGE: 'UPDATE_MESSAGE',
} as const;

// Organization Goals
export const OrgGoalActions = {
  UPDATE_PAGE_NUMBER: 'UPDATE_ORG_GOAL_PAGE_NUMBER',
  GET_PENDING: 'GET_ORG_GOAL_PENDING',
  GET: 'GET_ORG_GOAL',
  DELETE: 'DELETE_ORG_GOAL',
  FETCH: 'FETCH_ORG_GOAL',
  EDIT: 'EDIT_ORG_GOAL',
  ADD: 'ADD_ORG_GOAL',
  CLEAR: 'CLEAR_ORG_GOAL',
} as const;

// Team Projects
export const TeamProjectActions = {
  UPDATE_PAGE_NUMBER: 'UPDATE_TEAM_PROJECT_PAGE_NUMBER',
  GET_PENDING: 'GET_TEAM_PROJECT_PENDING',
  GET: 'GET_TEAM_PROJECT',
  EDIT: 'EDIT_TEAM_PROJECT',
  ADD: 'ADD_TEAM_PROJECT',
  CLEAR: 'CLEAR_TEAM_PROJECT',
  GET_ALL: 'GET_TEAM_PROJECTS',
  DELETE: 'DELETE_TEAM_PROJECT',
  FETCH: 'FETCH_TEAM_PROJECT',
} as const;

// UI Related
export const UIActions = {
  SET_PAGE_TITLE: 'SET_PAGE_TITLE',
  SET_SUB_NAV: 'SET_SUB_NAV',
  SET_NAVIGATION: 'SET_NAVIGATION',
  SET_DATA_ANCHOR: 'SET_DATA_ANCHOR',
} as const;

// Survey Related
export const SurveyActions = {
  QUESTIONS: {
    GET: 'GET_SURVEY_QUESTIONS',
    DELETE: 'DELETE_SURVEY_QUESTION',
    FETCH: 'FETCH_SURVEY_QUESTION',
    EDIT: 'EDIT_SURVEY_QUESTION',
    ADD: 'ADD_SURVEY_QUESTION',
    CLEAR: 'CLEAR_SURVEY_QUESTION',
  },
  COMPLIANCES: {
    GET: 'GET_SURVEY_COMPLIANCES',
    DELETE: 'DELETE_SURVEY_COMPLIANCE',
    FETCH: 'FETCH_SURVEY_COMPLIANCE',
    EDIT: 'EDIT_SURVEY_COMPLIANCE',
    ADD: 'ADD_SURVEY_COMPLIANCE',
    CLEAR: 'CLEAR_SURVEY_COMPLIANCE',
  },
  RESPONSES: {
    GET: 'GET_SURVEY_RESPONSES',
    DELETE: 'DELETE_SURVEY_RESPONSE',
    CLEAR: 'CLEAR_SURVEY_RESPONSE',
  },
  SET_VERSION: 'SET_SURVEY_VERSION',
  SET_FILTERS: 'SET_NEW_FILTERS',
} as const;

// Department Related
export const DepartmentActions = {
  GET_ALL: 'GET_DEPARTMENTS',
  DELETE: 'DELETE_DEPARTMENT',
  FETCH: 'FETCH_DEPARTMENT',
  EDIT: 'EDIT_DEPARTMENT',
  SAVE: 'SAVE_DEPARTMENT',
  CLEAR: 'CLEAR_DEPARTMENT',
} as const;

// Employee Related
export const EmployeeActions = {
  PERMISSIONS: {
    GET: 'GET_EMPLOYEE_PERMISSIONS',
    GET_PENDING: 'PENDING_EMPLOYEE_PERMISSION',
    GET_ORG: 'GET_EMPLOYEE_ORG_PERMISSIONS',
    DELETE: 'DELETE_EMPLOYEE_PERMISSION',
    FETCH: 'FETCH_EMPLOYEE_PERMISSION',
    EDIT: 'EDIT_EMPLOYEE_PERMISSION',
    ADD: 'ADD_EMPLOYEE_PERMISSION',
    CLEAR: 'CLEAR_EMPLOYEE_PERMISSION',
  },
  ROLES: {
    GET: 'GET_EMPLOYEE_ROLE',
    GET_ALL: 'GET_EMPLOYEE_ROLES',
    FETCH: 'FETCH_EMPLOYEE_ROLE',
    EDIT: 'EDIT_EMPLOYEE_ROLE',
    CLEAR: 'CLEAR_EMPLOYEE_ROLE',
  },
  LOAD: 'LOAD_EMPLOYEES',
  PULL: 'PULL_EMPLOYEE',
  GET_SAFE_LIST: 'GET_SAFE_EMPLOYEE_LIST',
} as const;

// Team Related
export const TeamActions = {
  GET_ALL: 'GET_TEAMS',
  FETCH: 'FETCH_TEAM',
  EDIT: 'EDIT_TEAM',
  SAVE: 'SAVE_TEAM',
  CLEAR: 'CLEAR_TEAM',
  RESET_CREATED: 'RESET_CREATED_TEAM',
} as const;

// Signup Related
export const SignupActions = {
  HOME: 'SIGNUP_HOME',
  DEPARTMENT: 'SIGNUP_DEPARTMENT',
  TEAM: 'SIGNUP_TEAM',
  EMPLOYEE: 'SIGNUP_EMPLOYEE',
} as const;

// Organization Management
export const OrganizationActions = {
  GET_AM: 'GET_AM_ORGANIZATION',
  SET_AUTH: 'SET_AUTH_ORGANIZATION',
  SET_MENU: 'SET_AM_MENU',
  GET_AM_TEAM: 'GET_AM_TEAM',
  GET_AM_EMPLOYEE: 'GET_AM_EMPLOYEE',
  ROUTE_PATH: 'ROUTE_PATH',
  CLEAR_AM: 'CLEAR_AM',
} as const;

// Categories and Filters
export const CategoryActions = {
  GET_ORG_CATEGORIES: 'GET_EMPLOYEE_ORG_CATEGORIES',
  GET_USER_CATEGORIES: 'GET_EMPLOYEE_USER_CATEGORIES',
  GET_OUTCOME_QUESTIONS: 'GET_OUTCOME_QUESTIONS',
  GET_MEMBER_FILTERS: 'GET_MEMBER_FILTERS',
  SET_MEMBER_FILTERS: 'SET_MEMBER_FILTERS',
  SET_MEMBER_SEARCH_FILTERS: 'SET_MEMBER_SEARCH_FILTERS',
  CLEAR_ORG_CATEGORY: 'CLEAR_EMPLOYEE_ORG_CATEGORY',
} as const;

// Recommendations
export const RecommendationActions = {
  GET: 'GET_CHAT_RECOMMENDATION',
  FETCH: 'FETCH_CHAT_RECOMMENDATION',
  ADD: 'ADD_CHAT_RECOMMENDATION',
  DELETE: 'DELETE_CHAT_RECOMMENDATION',
  EDIT: 'EDIT_CHAT_RECOMMENDATION',
  ERROR: 'CHAT_RECOMMENDATION_ERROR',
} as const;

// Assessment Periods
export const AssessmentPeriodActions = {
  SET: 'SET_ASSESSMENT_PERIOD',
  SET_PREVIOUS: 'SET_PREVIOUS_ASSESSMENT_PERIOD',
  CLEAR: 'CLEAR_ASSESSMENT_PERIODS',
} as const;

// Answers
export const AnswerActions = {
  SET: 'SET_ANSWERS',
  FETCH_CULTURE: 'FETCH_CULTURE_ANSWER',
  ADD: 'ADD_ANSWER',
  ADD_CULTURE: 'ADD_CULTURE_ANSWER',
  ADD_MOOD: 'ADD_MOOD_ANSWER',
  POST: 'POST_ANSWER',
  CLEAR: 'CLEAR_ANSWER',
} as const;

// Data Management
export const DataActions = {
  SET_FILTERED: 'SET_FILTERED_DATA',
  SET_FILTERED_LAST: 'SET_FILTERED_LAST_DATA',
  SET_SELECTED_QUESTION: 'SET_SELECTED_QUESTION',
  SET_DATES: 'SET_DATA_DATES',
  SET_CATEGORY: 'SET_CATEGORY_DATA',
  SET_RAW: 'SET_RAW_DATA',
  SET_QUESTIONS: 'SET_QUESTIONS',
  SET_SELECTED_FILTERS: 'SET_SELECTED_FILTERS',
} as const;

// Action Plans
export const ActionPlanActions = {
  GET_ALL: 'GET_ALL_ACTION_PLANS',
  FETCH: 'FETCH_ACTION_PLAN',
  CREATE: 'CREATE_ACTION_PLAN',
  UPDATE: 'UPDATE_ACTION_PLAN',
  DELETE: 'DELETE_ACTION_PLAN',
  GET_ACTIVITY: 'GET_ACTION_PLAN_ACTIVITY',
  GET_ACTIVITIES: 'GET_ACTION_PLAN_ACTIVITIES',
} as const;

// Employee Records
export const EmployeeRecordActions = {
  GET: 'GET_EMPLOYEE_RECORD',
  ADD: 'ADD_EMPLOYEE_RECORD',
  DELETE: 'DELETE_EMPLOYEE_RECORD',
  UPDATE: 'UPDATE_EMPLOYEE_RECORD',
  FETCH: 'FETCH_EMPLOYEE_RECORD',
  CLEAR: 'CLEAR_EMPLOYEE_RECORD',
} as const;

// Employee Record Values
export const EmployeeRecordValueActions = {
  GET: 'GET_EMPLOYEE_RECORD_VALUE',
  ADD: 'ADD_EMPLOYEE_RECORD_VALUE',
  DELETE: 'DELETE_EMPLOYEE_RECORD_VALUE',
  UPDATE: 'UPDATE_EMPLOYEE_RECORD_VALUE',
  FETCH: 'FETCH_EMPLOYEE_RECORD_VALUE',
  CLEAR: 'CLEAR_EMPLOYEE_RECORD_VALUE',
} as const;

// File Upload Related
export const FileUploadActions = {
  START: 'START_FILE_UPLOAD',
  GET_ALL: 'GET_FILE_UPLOADS',
  DELETE: 'DELETE_FILE_UPLOAD',
  FETCH: 'FETCH_FILE_UPLOAD',
  EDIT: 'EDIT_FILE_UPLOAD',
  ADD: 'ADD_FILE_UPLOAD',
  CLEAR: 'CLEAR_FILE_UPLOAD',
  CLEAR_CREATED: 'CLEAR_CREATED_FILE_UPLOAD',
} as const;

// Type for all action types
export type ActionType =
  | (typeof ErrorActions)[keyof typeof ErrorActions]
  | (typeof MessageActions)[keyof typeof MessageActions]
  | (typeof OrgGoalActions)[keyof typeof OrgGoalActions]
  | (typeof TeamProjectActions)[keyof typeof TeamProjectActions]
  | (typeof UIActions)[keyof typeof UIActions]
  | (typeof SurveyActions)[keyof typeof SurveyActions]
  | (typeof DepartmentActions)[keyof typeof DepartmentActions]
  | (typeof EmployeeActions)[keyof typeof EmployeeActions]
  | (typeof TeamActions)[keyof typeof TeamActions]
  | (typeof SignupActions)[keyof typeof SignupActions]
  | (typeof OrganizationActions)[keyof typeof OrganizationActions]
  | (typeof CategoryActions)[keyof typeof CategoryActions]
  | (typeof RecommendationActions)[keyof typeof RecommendationActions]
  | (typeof AssessmentPeriodActions)[keyof typeof AssessmentPeriodActions]
  | (typeof AnswerActions)[keyof typeof AnswerActions]
  | (typeof DataActions)[keyof typeof DataActions]
  | (typeof ActionPlanActions)[keyof typeof ActionPlanActions]
  | (typeof EmployeeRecordActions)[keyof typeof EmployeeRecordActions]
  | (typeof EmployeeRecordValueActions)[keyof typeof EmployeeRecordValueActions]
  | (typeof FileUploadActions)[keyof typeof FileUploadActions];
